<template>
  <button
    @click="removeFilter(filter, isCategory ? 'category' : 'filter')"
    :class="{'-category': isCategory}"
  >
    <div v-if="!isCategory">
      <svg>
        <use :xlink:href="`#icon-${filter.icon}`"></use>
      </svg>
      {{ filter.textWithValue }}
    </div>
    <div v-else>
      {{ filter.label }}
    </div>
    <span>X</span>
  </button>
</template>
<script>
export default {
  props: {
    isCategory: {
      type: Boolean,
      default: false,
    },
    filter: {
      type: Object,
      required: true,
    },
  },
  methods: {
    removeFilter(filter, type) {
      this.$store.commit('vehicles/filters/REMOVE_ACTIVE_FILTER', { filter, type })
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../../../../_src/sass/config/vars";
@import "../../../../../_src/sass/config/mixins";

button {
  align-items: center;
  background: black;
  border: none;
  color: white;
  display: flex;
  font-family: $f-graphie-book;
  height: 30px;
  justify-content: center;
  line-height: 1;
  margin: 0;
  padding: 8px;

  @include font-size(12px);

  &.-category {
    background: $black;
  }
}

div {
  align-items: center;
  display: flex;
}

svg {
  fill: white;
  margin-right: 5px;
  max-height: 18px;
  max-width: 16px;
}

span {
  cursor: pointer;
  display: inline-block;
  margin: 0 0 0 5px;
}
</style>
